module.exports = __webpack_public_path__ + "0cc27fb96102ba74fd2f4befd1bab198.pdf";